document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#stitch-type-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "stitchType"
      );

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.stitch;

          console.log(
            "STITCH TYPE:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);